<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}
          <v-chip
            :color="statusColor"
            small
          >{{ form.Status }}</v-chip>
        </span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text ref="cardContent">
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col cols="12">

                <v-textarea
                  v-if="form.RejectReason"
                  v-model="form.RejectReason"
                  label="退回原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>

                <v-autocomplete
                  :items="userOptions"
                  item-text="Name"
                  item-value="ID"
                  label="員工"
                  v-model="form.UserID"
                  :rules="formRules.UserID"
                  readonly
                ></v-autocomplete>

                <v-textarea
                  v-model="form.Content"
                  rows="1"
                  auto-grow
                  label="訊息"
                  readonly
                  :rules="formRules.Content"
                ></v-textarea>

                <v-text-field
                  v-model="form.Days"
                  label="天數"
                  type="number"
                  step="0.5"
                  min="-1000000"
                  max="10000000"
                  :rules="formRules.Days"
                  readonly
                ></v-text-field>
                
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          v-if="isSignEnabled"
          color="white darken-1"
          depressed
          outlined
          text
          @click="reject"
        >拒絕</v-btn>
        <v-btn
          v-if="isSignEnabled"
          color="white darken-1"
          depressed
          outlined
          text
          @click="pass"
        >同意</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import TodoItemAutoComplete from "@/data/todo-item/TodoItemAutoComplete.js";
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {},
    defaultForm: {
      Name: ""
    },
    categoryOptions: [
      { Name: "事假" },
      { Name: "病假" },
      { Name: "生理假" },
      { Name: "特休" },
      { Name: "補休" },
      { Name: "曠職" },
      { Name: "其他" }
    ]
  }),
  computed: {
    formRules() {
      return {
        Category: [v => !!v || "請輸入名稱"],
        Reason: [v => !!v || "請輸入原因"],
        AgentID: [v => !!v || "請選擇代理人"],
        Begin: [v => !!v || "請輸入開始時間"],
        End: [v => !!v || "請輸入結束時間"]
      };
    },
    formTitle() {
      return "補休";
    },
    statusColor() {
      if (this.form.Status == "退回")
        return "red";
      if (
        this.form.Status == "審核中"
      )
        return "green";
      if (this.form.Status == "通過") return "primary";
      return "";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    editingIdx() {
      return this.$store.state.compensatoryTime.list.findIndex(o => o.ID == this.id);
    },
    userOptions() {
      return this.users.map(o => {
        return { ID: o.ID, Name: o.Profile.Name };
      });
    },
    isSignEnabled() {
      var vm = this
      const findUserDepartmentID = userID =>
        (vm.$store.getters.userDepartments.find(o => o.UserID == userID) || {})
          .DepartmentID;
      return (
        (this.form.Status == "審核中" &&
          this.myLevel == 10 &&
          findUserDepartmentID(this.form.UserID) == this.myDepartment.ID) 
      );
    },
    ...mapGetters([
      "users",
      "userPositions",
      "userDepartments",
      "me",
      "myLevel",
      "myDepartment"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    reject() {
      var reason = prompt("請輸入退回原因");
      if (!reason) return alert("請輸入退回原因");
      let rejectReasonKey = "RejectReason";
      let payload = {
        ID: this.form.ID
      };
      payload[rejectReasonKey] = reason;

      this.isLoading = true;
      this.$services.compensatoryTime.reject(this, payload)
        .then(res => {
          let newStatus = "退回";
          this.$set(
            this.$store.state.compensatoryTime.list[this.editingIdx],
            "Status",
            newStatus
          );
          this.$set(
            this.$store.state.compensatoryTime.list[this.editingIdx],
            rejectReasonKey,
            reason
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'compensatoryTime', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    pass() {
      this.isLoading = true;
      this.$services.compensatoryTime.sign(this, this.form.ID)
        .then(res => {
          let newStatus = "通過"
          this.$set(
            this.$store.state.compensatoryTime.list[this.editingIdx],
            "Status",
            newStatus
          );
          TodoItemAutoComplete.notifyActionDetected(this, 'compensatoryTime', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      if (!this.value) return;
      if (this.id < 0 || this.editingIdx < 0) {
        this.isLoading = false;
        alert("發生異常：無法找到編輯物件");
        return;
      }
      if (this.$refs.cardContent) {
        this.$nextTick(() => this.$refs.cardContent.scrollTo(0, 0));
      }
      this.form = JSON.parse(
        JSON.stringify(this.$store.state.compensatoryTime.list[this.editingIdx])
      );
      this.form.Days = this.form.Hours/8
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.compensatoryTime.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>